var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZonesBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 45 0 C 30.026 0 17.845 12.182 17.845 27.155 c 0 4.165 0.919 8.161 2.744 11.905 c 2.511 5.04 9.861 17.467 17.644 30.623 l 3.79 6.411 c 0.621 1.053 1.754 1.699 2.977 1.699 s 2.355 -0.647 2.977 -1.699 l 3.788 -6.408 c 7.73 -13.066 15.033 -25.413 17.593 -30.52 c 0.023 -0.044 0.048 -0.089 0.069 -0.134 c 1.81 -3.719 2.729 -7.715 2.729 -11.877 C 72.155 12.182 59.974 0 45 0 z M 45 42.877 c -9.196 0 -16.679 -7.482 -16.679 -16.678 C 28.321 17.003 35.804 9.52 45 9.52 s 16.678 7.483 16.678 16.679 S 54.196 42.877 45 42.877 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 59.65 66.845 c -0.402 0.682 -0.808 1.371 -1.217 2.066 c 5.772 1.328 9.542 3.483 9.542 5.923 c 0 4.038 -10.286 7.311 -22.974 7.311 s -22.974 -3.273 -22.974 -7.311 c 0 -2.44 3.77 -4.594 9.542 -5.922 c -0.41 -0.695 -0.816 -1.384 -1.217 -2.066 c -10.637 2.013 -17.936 6.148 -17.936 10.924 C 12.414 84.524 27.003 90 45 90 s 32.586 -5.476 32.586 -12.231 C 77.586 72.992 70.286 68.858 59.65 66.845 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZonesBtn);
export default __webpack_public_path__ + "static/media/zones-btn.e46405aaf93c49dc195e0770a45d8488.svg";
export { ForwardRef as ReactComponent };